module.exports = __webpack_public_path__ + "static/media/enlarge-horizontal.13c52094.svg";